export const selectLoading = state => state.crm.isLoading;

export const selectError = state => state.crm.error;

// export const selectRecords = state => state.crm.records;

export const selectServiceData = state => state.crm.serviceData;

export const selectVisits = state => state.crm.visits;

export const selectMonthlyLoadCrm = state => state.crm.load;

export const selectDayRecords = state => state.crm.dayRecords;

export const selectRecordById = state => state.crm.record;

export const selectDates = state => state.crm.dates;

export const selectCarDataByPlate = state => state.crm.carDataByPlate;

export const selectIsServiceDataLoading = state =>
  state.crm.isServiceDataLoading;

export const selectIsCarByPlateLoading = state => state.crm.isCarByPlateLoading;